import React from "react";
import { Link } from "react-router-dom";
import "../styles/AdminPanel.css";

const AdminPanel = () => {
  return (
    <div className="admin-panel">
      <h2>Panel de Administración</h2>
      <ul>
        <li>
          <Link to="/admin/events">Gestión de Eventos</Link>
        </li>
        <li>
          <Link to="/admin/media">Gestión de Medios</Link>
        </li>
        <li>
          <Link to="/admin/contact">Gestión de Mensajes de Contacto</Link>
        </li>
        {/* Puedes añadir más enlaces aquí, por ejemplo: */}
        {/* <li><Link to="/admin/users">Gestión de Usuarios</Link></li> */}
      </ul>
    </div>
  );
};

export default AdminPanel;
